module.exports = __webpack_public_path__ + "media/images/logos/modalhr-logo-web-orange-white-8f5017035574e287fd00fbdaf933c4a4.png";